import { DeckCardSlot } from "types/item-cards/deck-item-slot";

export type { DeckCardSlot };

export const DECK_CARD_SLOT_COUNT = 32;
export const DECK_POKE_SLOT_COUNT = 8;

/** A deck can enter a match only once full (32 card slots + 8 pokes). */
export const isDeckValidForMatch = (
  cardSlots: DeckCardSlot[],
  pokeSlots: number[] = [],
): boolean =>
  cardSlots.length === DECK_CARD_SLOT_COUNT && pokeSlots.length === DECK_POKE_SLOT_COUNT;
